// extracted by mini-css-extract-plugin
module.exports = {"claim":"Claim_claim__TwNKI","content":"Claim_content__tSFfK","word":"Claim_word__pZIQ0","space":"Claim_space__t8TXp","logo":"Claim_logo__q_9vQ","dot":"Claim_dot___2dGt"};